<template>
    <div class="tree-registration">
        <carousel v-if="model.carousel" :model="model.carousel" class="carousel">
        </carousel>
        <main>
            <post-code-form :model="model.postCodeDto"></post-code-form>
            <registration-soon-form v-if="collectionLookupResult === CollectionLookup.REGISTRATION_SOON"
                :model="model.registrationSoon"></registration-soon-form>
            <registration-close-form
                v-else-if="collectionLookupResult === CollectionLookup.REGISTRATION_CLOSED || collectionLookupResult === CollectionLookup.REGISTRATION_FULL"
                :model="model.noCollectionDto"></registration-close-form>
            <registration-open-form v-else-if="collectionLookupResult === CollectionLookup.REGISTRATION_OPEN"
                :model="model.openCollectionDto"></registration-open-form>
        </main>
    </div>
</template>
<script lang="ts" setup>
import { CollectionLookup, PostCodeDataKey, type ITreeRegistrationProps } from './TreeRegistration.model';
import Carousel from '@/components/Carousel/Carousel.vue';
import PostCodeForm from './PostCodeForm/PostCodeForm.vue';
import { provide, ref } from 'vue';
import RegistrationSoonForm from './RegistrationSoonForm/RegistrationSoonForm.vue';
import RegistrationCloseForm from './RegistrationCloseForm/RegistrationCloseForm.vue';
import type { IHospice } from '@/api/registerTree';
import RegistrationOpenForm from './RegistrationOpenForm/RegistrationOpenForm.vue';

const { model } = defineProps<ITreeRegistrationProps>()

const collectionLookupResult = ref(CollectionLookup.NONE)
const postCode = ref("");
const hospices = ref<IHospice[] | null>([]);
provide(PostCodeDataKey, { collectionLookupResult, hospices, postCode })
</script>
<style lang="scss" scoped>
.carousel {
    width: 100%;
}

main {
    margin-top: -20px;
    z-index: 2;
    position: relative;
    border-radius: 24px;
    border: 1px solid lightgray;
    padding: 12px 24px;
    background-color: #FFF;
    display: flex;
    flex-direction: column;
    max-width: 95%;
    width: 100%;
}

.tree-registration {
    display: flex;
    flex-direction: column;
    align-items: center;
}

@media (min-width: 768px) {
    .carousel {
        max-width: 85%;
        width: 100%;
    }

    main {
        max-width: 80%;
        padding: 40px 35px;
    }
}
</style>